import React,{Component} from 'react';
import "./style.less";
import {connect} from 'react-redux';
import {NavBar,InputItem, Toast} from "antd-mobile";
import {changePwd} from '../../../service/loginService';
@connect(
    state => ({userInfo: state.userInfo})
)
export default class ResetPassword extends Component{
    constructor(props) {
        super(props);
        this.state={
            oldPsd:'',
            newPsd:'',
            againNewPsd:''
        }
    }
    Change = (v,value) => {
        this.setState({
            [value]:v
        });
    };
    add =()=>{
        if(this.state.oldPsd == "" || this.state.oldPsd == "" || this.state.againNewPsd == ""){
            Toast.info("密码不能为空！");
        }
        else if(this.state.oldPsd.length < 6 || this.state.oldPsd.length < 6 || this.state.againNewPsd.length < 6){
                Toast.info("密码最少6位！");
           
        }else if(this.state.newPsd != this.state.againNewPsd){
            Toast.info("新密码两次密码输入不一致，重新输入！");
        }else{
            let params = {
                "token":this.props.userInfo.token,
                "data":{
                    "passwd":this.state.oldPsd,
                    "newPasswd":this.state.againNewPsd
                }
            };
            changePwd(params)
                .then((res) => {
                    console.log(res)
                    if (res.data.code === '0000') {
                        Toast.info("修改成功!",2,()=>this.props.history.goBack())
                     }
                     else {
                         Toast.info(res.data.msg);
                     }
                }).catch(function (error) {
                console.log(error);
            });
        }

    }
    render(){
        return(
            <div className="resetPassword">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconmorenfanhui" onClick={() => this.props.history.goBack()} />}
                >重置密码</NavBar>
                <div className="content">
                    <InputItem
                        type="text"
                        maxLength={18}
                        placeholder="请输入原密码"
                        value={this.state.oldPsd} 
                        onChange={(v) => this.Change(v,'oldPsd')}
                    >原密码</InputItem>

                    <InputItem
                        maxLength={18}
                        placeholder="请输入新密码"
                        value={this.state.newPsd}
                        type="text"
                        onChange={(v) => this.Change(v,'newPsd')}
                    >新密码</InputItem>
                    <InputItem
                        maxLength={18}
                        placeholder="请再次输入新密码"
                        value={this.state.againNewPsd}
                        type="text"
                        onChange={(v) => this.Change(v,'againNewPsd')}
                    >再次确认</InputItem>
                </div>
                <button className="addBtn" onClick={()=>this.add()}>确认修改</button>
                <div className="forgetPwd" onClick={()=>this.props.history.push('/resetPwd')}><span>忘记原密码？</span></div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Member/resetPassword/index.js